import React from "react";
import PageHero from "./modules/PageHero/PageHero";
import CategoryTiles from "./modules/CategoryTiles/CategoryTiles";
import ProductsSlider from "./modules/ProductSlider/ProductSlider";
import TwoColumnContent from "./modules/TwoColumnContent/TwoColumnContent";
import ThreeColumnContent from "./modules/ThreeColumnContent/ThreeColumnContent";
import ContentAndSidebar from "./modules/ContentAndSidebar/ContentAndSidebar";
import IconGrid from "./modules/IconGrid/IconGrid";
import SubscribeToNewsletter from "./modules/SubscribeToNewsletter/SubscribeToNewsletter";
import Banner from "./modules/Banner/Banner";
import ContactForm from "./modules/ContactForm/ContactForm";
import CalculatorModule from "./modules/Calculator/CalculatorModule";
import GalleryModule from "./modules/Gallery/GalleryModule";
import Map from "./modules/Map/Map";
import ConstantContactModule from "./modules/ConstantContact/ConstantContactModule";
import FeatureHighlights from "./modules/FeatureHighlights/FeatureHighlights";
import SplitContent from "./modules/SplitContent/SplitContent";
import ServicesSummary from "./modules/ServicesSummary/ServicesSummary";
import LatestPosts from "./modules/LatestPosts/LatestPosts";
import Separator from "./modules/Separator/Separator";
import RichTextWithBackground from "./modules/RichTextWithBackground/RichTextWithBackground";
import SideBySide from "./modules/SideBySide/SideBySide";
import ImagesList from "./modules/ImagesList/ImagesList";
import ProductGrid from "./modules/ProductGrid/ProductGrid";
import CollapsedContent from "./modules/CollapsedContent/CollapsedContent";
import QuoteSlider from "./modules/QuoteSlider/QuoteSlider";
import { GridPost } from "../Templates/PostTemplate/styled";
import IconBar from "./modules/IconBar/IconBar";
import QipHero from "./modules/QipHero/QipHero";
import { QipTextBanner } from "./modules/QipTextBanner/QipTextBanner";
import { Qip3Columns } from "./modules/Qip3Columns/Qip3Columns";
import { QipFeaturedImageText } from "./modules/QipFeaturedImageText/QipFeaturedImageText";
import { QipCtaBanner } from "./modules/QipCtaBanner/QipCtaBanner";
import { QipCtaCards } from "./modules/QipCtaCards/QipCtaCards";
import { SupportModule } from "./modules/SupportModule/SupportModule";
import { FirmwareVersionsComponent } from "./modules/FirmwareVersionsComponent/FirmwareVersionsComponent";
import { Faq } from "./modules/Faq/Faq";

export default function ModuleFactory({ module }) {
  let moduleComponent = null;
  switch (module.section_name) {
    case "hero":
      moduleComponent = (
        <PageHero
          mediaType={module.media_type}
          image={module.image}
          video={module.video}
          heading={module.heading}
          headingColor={module.heading_color}
          copy={module.copy}
          copyColor={module.copy_color}
          cta={module.cta}
          ctaColor={module.cta_color}
          ctaAlt={module.cta_alt}
          ctaColorAlt={module.cta_color_alt}
        />
      );
      break;

    case "qip_hero":
      moduleComponent = <QipHero slides={module.slides} />;
      break;

    case "qip_text_banner":
      moduleComponent = (
        <QipTextBanner
          title={module.title}
          copy={module.copy}
          margin={module.margin}
          hideLine={module.hide_line}
          useCustomValue={module.use_custom_value}
          customMarginTop={module.custom_margin_top}
          customMarginBottom={module.custom_margin_bottom}
        />
      );
      break;

    case "qip_3_columns":
      moduleComponent = (
        <Qip3Columns
          title={module.title}
          copy={module.copy}
          columns={module.columns}
        />
      );
      break;

    case "qip_featured_image_text":
      moduleComponent = <QipFeaturedImageText items={module.items} />;
      break;

    case "separator":
      moduleComponent = (
        <Separator
          margin={module.margin}
          hideLine={module.hide_line}
          useCustomValue={module.use_custom_value}
          customMarginTop={module.custom_margin_top}
          customMarginBottom={module.custom_margin_bottom}
        />
      );
      break;

    case "feature_highlights":
      moduleComponent = (
        <FeatureHighlights
          heading={module.heading}
          features={module.features}
          bgColor={module.background_color}
        />
      );
      break;

    case "split_content":
      moduleComponent = (
        <SplitContent
          title={module.title}
          copy={module.copy}
          image={module.image}
        />
      );
      break;

    case "collapsed_content":
      moduleComponent = (
        <CollapsedContent
          title={module.title}
          copy={module.copy}
          image={module.image}
        />
      );
      break;

    case "side_by_side":
      moduleComponent = (
        <SideBySide
          title={module.title}
          copy={module.copy}
          image={module.image}
          cta={module.cta}
          orientation={module.orientation}
        />
      );
      break;

    case "services_summary":
      moduleComponent = (
        <ServicesSummary heading={module.heading} services={module.services} />
      );
      break;

    case "rich_text_with_background":
      moduleComponent = (
        <RichTextWithBackground
          bgColor={module.background_color}
          copy={module.copy}
          cta={module.cta}
          reduceMargins={module.reduce_margins}
        />
      );
      break;

    case "images_list":
      moduleComponent = (
        <ImagesList copy={module.copy} images={module.images} />
      );
      break;

    case "quote_slider":
      moduleComponent = (
        <QuoteSlider title={module.title} quotes={module.quotes} />
      );
      break;

    case "latest_posts":
      moduleComponent = (
        <LatestPosts title={module.title} posts={module.posts} />
      );
      break;

    case "product_category_tiles":
      // categories
      // tiles_per_row
      moduleComponent = (
        <CategoryTiles
          categoryIds={module.categories}
          tilesPerRow={module.tiles_per_row}
        />
      );
      break;

    case "product_slider":
      // title
      // products
      moduleComponent = (
        <ProductsSlider title={module.title} productTypes={module.products} />
      );
      break;

    case "product_grid":
      // title
      // products
      moduleComponent = (
        <ProductGrid
          title={module.title}
          productTypes={module.products}
          useShortDescription={module.use_short_description}
        />
      );
      break;

    case "2_column_content":
      // left
      // right
      moduleComponent = (
        <TwoColumnContent left={module.left} right={module.right} />
      );
      break;

    case "3_column_content":
      // theme
      // title
      // first
      // second
      // third
      moduleComponent = (
        <ThreeColumnContent
          theme={module.theme}
          title={module.title}
          first={module.first}
          second={module.second}
          third={module.third}
          reduceMargins={module.reduce_margins}
          centerTitle={module.center_title}
        />
      );
      break;

    case "content_and_sidebar":
      // sidebar_position
      // content
      // sidebar
      moduleComponent = (
        <ContentAndSidebar
          sidebarPosition={module.sidebar_position}
          content={module.content}
          sidebarModules={module.sidebar}
        />
      );
      break;

    case "icon_grid":
      // icons_title
      // icons
      moduleComponent = (
        <IconGrid title={module.icons_title} icons={module.icons} />
      );
      break;

    case "icon_bar":
      moduleComponent = <IconBar icons={module.icons} />;
      break;

    case "banner":
      // image
      // text
      // cta
      moduleComponent = (
        <Banner
          image={module.image}
          textAlign={module.text_align}
          text={module.text}
          cta={module.cta}
        />
      );
      break;

    case "subscribe_to_newsletter":
      // headline
      // title
      moduleComponent = (
        <SubscribeToNewsletter
          headline={module.headline}
          title={module.title}
        />
      );
      break;

    case "contact_form":
      // title
      moduleComponent = <ContactForm title={module.title} />;
      break;

    case "coverage_calculator":
      // title
      moduleComponent = <CalculatorModule title={module.title} />;
      break;

    case "gallery":
      // title
      moduleComponent = (
        <GalleryModule title={module.title} items={module.items} />
      );
      break;

    case "map":
      // title
      // address
      // show_details
      // phone
      // fax
      moduleComponent = (
        <Map
          title={module.title}
          address={module.address}
          showDetails={module.show_details}
          phone={module.phone}
          fax={module.fax}
          map={module.map}
        />
      );
      break;

    case "constant_contact":
      moduleComponent = (
        <ConstantContactModule dataFormId={module.data_form_id} />
      );
      break;

    case "qip_cta_banner":
      moduleComponent = (
        <QipCtaBanner
          title={module.title}
          copy={module.copy}
          cta={module.cta}
          bgImage={module.bg_image}
        />
      );
      break;

    case "qip_cta_cards":
      moduleComponent = (
        <QipCtaCards
          title={module.title}
          cards={module.cards}
          links={module.links}
        />
      );
      break;

    case "support_module":
      moduleComponent = (
        <SupportModule
          title={module.title}
          description={module.description}
          cta={module.cta}
          cta_description={module.cta_description}
          contacts={module.contacts}
          cta_style={module.cta_style}
        />
      );
      break;

    case "firmware_versions_component":
      moduleComponent = (
        <FirmwareVersionsComponent
          title={module.title}
          description={module.description}
          label={module.label}
          buttonLabel={module.button_label}
          releaseNotes={module.release_notes}
          firmwareVersions={module.firmware_versions}
        />
      );
      break;

    case "faq":
      moduleComponent = <Faq title={module.title} items={module.items} />;
      break;

    default:
      moduleComponent = null;
      break;
  }

  const excludedModules = [
    "hero",
    "feature_highlights",
    "qip_hero",
    "qip_featured_image_text",
    "separator",
    "qip_text_banner",
    "qip_cta_banner",
    "services_summary",
  ];

  if (moduleComponent && !excludedModules.includes(module.section_name)) {
    return <GridPost>{moduleComponent}</GridPost>;
  }

  return moduleComponent;
}
